import React from 'react'
import ScrollbarsCustom, { ScrollbarProps } from 'react-scrollbars-custom'

import { StyledScrollbars } from './styles'

interface IProps extends ScrollbarProps {
    height?: number | string
}

export const Scrollbars: React.FC<IProps> = ({
    height,
    children,
    style,
    trackYProps,
    trackXProps,
    thumbYProps,
    thumbXProps,
    ...props
}) => {
    return (
        <ScrollbarsCustom
            {...props}
            style={{ ...style, height: height ?? '100%' }}
            trackYProps={{ ...trackYProps, style: { right: 4, width: 6, ...trackYProps?.style } }}
            thumbYProps={{ ...thumbYProps, style: { background: 'var(--gray-600)', ...thumbYProps?.style } }}
            trackXProps={{ ...trackXProps, style: { height: 6, ...trackXProps?.style } }}
            thumbXProps={{ ...thumbXProps, style: { background: 'var(--gray-600)', ...thumbXProps?.style } }}
        >
            {children}
        </ScrollbarsCustom>
    )
}
